module.exports = __webpack_public_path__ + "media/audio24.7c783a44.wav";